// Test IDs for the post-session summary / recap screen.
export const RECAP = {
    root: 'recap-root',
    title: 'recap-title',
    duration: 'recap-duration',
    totalVolume: 'recap-total-volume',
    setCount: 'recap-set-count',
    prCount: 'recap-pr-count',
    exerciseList: 'recap-exercise-list',
    exerciseRow: 'recap-exercise-row', // -{exercise_id}
    doneBtn: 'recap-done-btn',
    shareBtn: 'recap-share-btn',
    shareCard: 'recap-share-card',
};
